export default "__VITE_ASSET__6LCs1CFl__"